import { EffectsModal } from '../EffectsModal';

export const TotalMissingModal = ({ title, event }) => EffectsModal({
  title,
  desc: `Whenever possible, total number of missing from the ${event} and secondary effects are listed.`,
});
